export default "__VITE_ASSET__ZNyVO0T8__"